<div class="list-container">
    <div class="list-controls">
        @if (!showPriceSelectionBar()) {
            <div
                class="controls left">
            </div>
        }
        @if (!nearby && showPriceSelectionBar() && selectionComponent) {
            <div [class.active]="selectionComponent.selectionVisible()" class="controls left">
                <div
                    (click)="selectionComponent.toggleSelection()"
                    [class.active]="selectionComponent.selectionVisible()" class="fab small"
                    id="btn-selection"
                    matTooltip="Prijs en statusbalk"
                    matTooltipPosition="after">
                    @if (selectionComponent.selectionVisible()) {
                        <i class="fas fa-times"></i>
                    } @else {
                        <i class="fas fa-shopping-cart"></i>
                    }
                </div>
            </div>
        }
        <div class="search-container text-right me-2">
            <div (click)="tableView.set(!tableView())" class="fab small" matTooltip="{{tableView() ? 'Schakel naar lijstweergave' : 'Schakel naar tabelweergave'}}">
                @if (tableView()) {
                    <i class="fa-duotone fa-solid fa-list"></i>
                } @else {
                    <i class="fa-duotone fa-solid fa-table-cells"></i>
                }
            </div>
            @if (tableView()) {
                <mat-form-field class="ms-2">
                    <mat-label>Kolommen</mat-label>
                    <mat-select [formControl]="fcTableColumns" multiple>
                        @for (column of columnSelection; track column) {
                            <mat-option [value]="column.column">{{column.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
            @if (!isSmallDevice()) {
                <mat-form-field class="ms-2 me-2">
                    <mat-label>
                        Zoeken
                    </mat-label>
                    <input
                        (keyup)="search()"
                        [(ngModel)]="searchText"
                        autocomplete="off"
                        matInput
                        matTooltip="Opties: {{showPrice() ? '>100 (meer/minder dan 100 euro), ': ''}} 100 (punaise 100) of straat/plaats/figuratie/omschrijving"
                        matTooltipPosition="below">
                </mat-form-field>
            }
            <mat-form-field>
                <mat-label>
                    Sortering
                </mat-label>
                <mat-select (selectionChange)="orderChanged($event)" [(value)]="order">
                    <mat-option value="date">
                        Datum oplopend
                    </mat-option>
                    <mat-option value="-date">
                        Datum aflopend
                    </mat-option>
                    @if (showPrice()) {
                        <mat-option value="price">
                            Prijs oplopend
                        </mat-option>
                        <mat-option value="-price">
                            Prijs aflopend
                        </mat-option>
                    }
                    <mat-option value="number">
                        Nummer oplopend
                    </mat-option>
                    <mat-option value="-number">
                        Nummer aflopend
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
        <div class="controls">
            <div
                (click)="back()"
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below">
                <i class="fas fa-sign-out-alt"></i>
            </div>
            @if (!nearby && AuthorisationService.hasFeature('pushpinPartExcelExport') && !isCordova) {
                <div
                    (click)="excelExport()"
                    class="fab small"
                    id="btn-exportexcel"
                    matTooltip="Exporteer delen als Excel bestand"
                    matTooltipPosition="below">
                    <i class="fas fa-file-excel"></i>
                </div>
            }
            @if (!nearby && AuthorisationService.hasFeature('pushpinPartShapefileExport') && !isCordova) {
                <div
                    (click)="shapeFileExport()"
                    class="fab small"
                    id="btn-exportshapefile"
                    matTooltip="Exporteer locaties als ShapeFile"
                    matTooltipPosition="below">
                    <i class="fas fa-globe"></i>
                </div>
            }
            @if (!nearby && AuthorisationService.hasFeature('pushpinPartZipExport') && !isCordova) {
                <div
                    (click)="zipExport()"
                    class="fab small"
                    id="btn-exportzip"
                    matTooltip="Exporteer fotos in delen als ZIP bestand"
                    matTooltipPosition="below">
                    @if (!zipExporting()) {
                        <i class="fas fa-file-archive"></i>
                    } @else {
                        <i class="fas fa-spinner fa-spin"></i>
                    }
                </div>
            }
            <div
                class="fab small"
                id="btn-decorations"
                matTooltip="Profiel aanpassen"
                matTooltipPosition="below"
                routerLink="/profile">
                <i class="fas fa-user"></i>
            </div>
            <div
                (click)="toggleFilter()"
                [class.active]="filterComponent.filterVisible()"
                [class.ms-3]="filterComponent.filter.filterCount"
                [matBadge]="filterComponent.filter.filterCount"
                class="fab small" id="btn-filters"
                matBadgePosition="above before"
                matTooltip="Filters"
                matTooltipPosition="below">
                @if (filterComponent.filterVisible()) {
                    <i class="fas fa-times"></i>
                } @else {
                    <i class="fas fa-filter"></i>
                }
            </div>

        </div>
    </div>

    <div [class.disable]="filterComponent.filterVisible()" class="controls-bottom">
        <div
            [routerLink]="['/pushpins/map/', customerArea?.id ?? 'nearby', mapZoom(), mapCenter()?.lat, mapCenter()?.lng, {inspection: inspection()?.id}]"
            class="fab big"
            id="btn-Mapview"
            matTooltip="Kaartweergave"
            matTooltipPosition="before">
            <i class="fas fa-map"></i>
        </div>
    </div>


    @if (showList() && tableView()) {
        <div class="table-container">
            <div class="header">
                <table [style.min-width.px]="tableWidth" class="table-header">
                    <tr>
                        @for (column of header; track column) {
                            <th [style.min-width.px]="column.width">
                                {{column.name}}
                            </th>
                        }
                    </tr>
                </table>
            </div>
            <cdk-virtual-scroll-viewport #scrollviewport (scroll)="scrolling($event)" class="viewport" itemSize="30">
                <table [style.min-width.px]="tableWidth" class="table">
                    <ng-container *cdkVirtualFor="let pushpinPart of searchedPushpinParts(); let i = index">
                        <tr (click)="openPushpin(pushpinPart.pushpin['id'], pushpinPart.id)">
                            @if (tableColumns.get('number').visable) {
                                <td [style.max-width.px]="tableColumns.get('number').width" [style.min-width.px]="tableColumns.get('number').width">
                                    <div>{{pushpinPart.pushpin.number}}</div>
                                </td>
                            }
                            @if (tableColumns.get('updated_at').visable) {
                                <td [style.max-width.px]="tableColumns.get('updated_at').width" [style.min-width.px]="tableColumns.get('updated_at').width">
                                    <div>{{pushpinPart.updated_at | date : 'd MMM yyyy, H:mm'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('executedDate').visable) {
                                <td [style.max-width.px]="tableColumns.get('executedDate').width" [style.min-width.px]="tableColumns.get('executedDate').width">
                                    <div>{{pushpinPart['executedDate'] | date : 'd MMM yyyy, H:mm'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('zipcode').visable) {
                                <td [style.max-width.px]="tableColumns.get('zipcode').width" [style.min-width.px]="tableColumns.get('zipcode').width">
                                    <div>{{pushpinPart.pushpin.zipcode}}</div>
                                </td>
                            }
                            @if (tableColumns.get('place').visable) {
                                <td [style.max-width.px]="tableColumns.get('place').width" [style.min-width.px]="tableColumns.get('place').width">
                                    <div>{{pushpinPart.pushpin.place}}</div>
                                </td>
                            }
                            @if (tableColumns.get('street').visable) {
                                <td [style.max-width.px]="tableColumns.get('street').width" [style.min-width.px]="tableColumns.get('street').width">
                                    <div>{{pushpinPart.pushpin.street}}</div>
                                </td>
                            }
                            @if (tableColumns.get('housenumber').visable) {
                                <td [style.max-width.px]="tableColumns.get('housenumber').width" [style.min-width.px]="tableColumns.get('housenumber').width">
                                    <div>{{pushpinPart.pushpin.housenumber}}</div>
                                </td>
                            }
                            @if (tableColumns.get('price').visable) {
                                <td [style.max-width.px]="tableColumns.get('price').width" [style.min-width.px]="tableColumns.get('price').width">
                                    <div>€ {{pushpinPartPricesMap()[pushpinPart.id] | number:'1.2-2'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('inQuotation').visable) {
                                <td [style.max-width.px]="tableColumns.get('inQuotation').width" [style.min-width.px]="tableColumns.get('inQuotation').width">
                                    <div>{{pushpinPart.inQuotation}}</div>
                                </td>
                            }
                            @if (tableColumns.get('status').visable) {
                                <td [style.max-width.px]="tableColumns.get('status').width" [style.min-width.px]="tableColumns.get('status').width">
                                    <div>{{pushpinPart.status.name}}</div>
                                </td>
                            }
                            @if (tableColumns.get('decorationType').visable) {
                                <td [style.max-width.px]="tableColumns.get('decorationType').width" [style.min-width.px]="tableColumns.get('decorationType').width">
                                    <div>{{pushpinPart.decoration.type}}</div>
                                </td>
                            }
                            @if (tableColumns.get('decorationName').visable) {
                                <td [style.max-width.px]="tableColumns.get('decorationName').width" [style.min-width.px]="tableColumns.get('decorationName').width">
                                    <div>{{pushpinPart.decoration.name}}</div>
                                </td>
                            }
                            @if (tableColumns.get('material').visable) {
                                <td [style.max-width.px]="tableColumns.get('material').width" [style.min-width.px]="tableColumns.get('material').width">
                                    <div>
                                        <span [class.no-material]="pushpinPart.exclusive_material">
                                            {{pushpinPart.material.name}}
                                        </span>
                                        {{pushpinPart.primer ? ', Primer' : ''}}
                                    </div>
                                </td>
                            }
                            @if (tableColumns.get('paint_color').visable) {
                                <td [style.max-width.px]="tableColumns.get('paint_color').width" [style.min-width.px]="tableColumns.get('paint_color').width">
                                    <div>{{pushpinPart.paint_color.name}}</div>
                                </td>
                            }
                            @if (tableColumns.get('length').visable) {
                                <td [style.max-width.px]="tableColumns.get('length').width" [style.min-width.px]="tableColumns.get('length').width">
                                    <div>{{pushpinPart.length | number:'1.0-0'}} m</div>
                                </td>
                            }
                            @if (tableColumns.get('surface').visable) {
                                <td [style.max-width.px]="tableColumns.get('surface').width" [style.min-width.px]="tableColumns.get('surface').width">
                                    <div>{{pushpinPart.surface | number:'1.0-2'}} m<sup>2</sup></div>
                                </td>
                            }
                            @if (tableColumns.get('amount').visable) {
                                <td [style.max-width.px]="tableColumns.get('amount').width" [style.min-width.px]="tableColumns.get('amount').width">
                                    <div>{{pushpinPart.amount}}</div>
                                </td>
                            }
                            @if (tableColumns.get('crow').visable) {
                                <td [style.max-width.px]="tableColumns.get('crow').width" [style.min-width.px]="tableColumns.get('crow').width">
                                    <div>{{pushpinPart.crow}}</div>
                                </td>
                            }
                            @if (tableColumns.get('blast').visable) {
                                <td [style.max-width.px]="tableColumns.get('blast').width" [style.min-width.px]="tableColumns.get('blast').width">
                                    <div>{{pushpinPart.blast ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('stake_out').visable) {
                                <td [style.max-width.px]="tableColumns.get('stake_out').width" [style.min-width.px]="tableColumns.get('stake_out').width">
                                    <div>{{pushpinPart.stake_out ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('priority_figuration').visable) {
                                <td [style.max-width.px]="tableColumns.get('priority_figuration').width" [style.min-width.px]="tableColumns.get('priority_figuration').width">
                                    <div>{{pushpinPart.decoration.priority_figuration ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('turbo_burn').visable) {
                                <td [style.max-width.px]="tableColumns.get('turbo_burn').width" [style.min-width.px]="tableColumns.get('turbo_burn').width">
                                    <div>{{pushpinPart.turbo_burn ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('manual_burn').visable) {
                                <td [style.max-width.px]="tableColumns.get('manual_burn').width" [style.min-width.px]="tableColumns.get('manual_burn').width">
                                    <div>{{pushpinPart.manual_burn ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('night').visable) {
                                <td [style.max-width.px]="tableColumns.get('night').width" [style.min-width.px]="tableColumns.get('night').width">
                                    <div>{{pushpinPart.night ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('lat').visable) {
                                <td [style.max-width.px]="tableColumns.get('lat').width" [style.min-width.px]="tableColumns.get('lat').width">
                                    <div>{{pushpinPart.pushpin.lat ? 'Ja' : 'Nee'}}</div>
                                </td>
                            }
                            @if (tableColumns.get('lng').visable) {
                                <td [style.max-width.px]="tableColumns.get('lng').width"
                                    [style.min-width.px]="tableColumns.get('lng').width">{{pushpinPart.pushpin.lng ? 'Ja' : 'Nee'}}
                                </td>
                            }
                            @if (tableColumns.get('description').visable) {
                                <td [style.max-width.px]="tableColumns.get('description').width" [style.min-width.px]="tableColumns.get('description').width">
                                    <div>{{pushpinPart.description}}</div>
                                </td>
                            }
                            @if (tableColumns.get('reference').visable) {
                                <td [style.max-width.px]="tableColumns.get('reference').width" [style.min-width.px]="tableColumns.get('reference').width">
                                    <div>{{pushpinPart.pushpin?.reference}}</div>
                                </td>
                            }
                            @if (tableColumns.get('customer_note').visable) {
                                <td [style.max-width.px]="tableColumns.get('customer_note').width" [style.min-width.px]="tableColumns.get('customer_note').width">
                                    <div>{{pushpinPart.customer_note}}</div>
                                </td>
                            }
                        </tr>
                    </ng-container>
                </table>
            </cdk-virtual-scroll-viewport>
        </div>
    }

    @if (showList() && !tableView()) {
        <div class="viewport-container">
            @if (!tableView()) {
                <cdk-virtual-scroll-viewport #scrollviewport class="viewport" itemSize="207">
                    <div class="list">
                        @if ((searchedPushpinParts() && searchedPushpinParts().length === 0) || !searchedPushpinParts()) {
                            <div>
                                Er zijn geen markeringsitems gevonden
                            </div>
                        }
                        <ng-container *cdkVirtualFor="let pushpinPart of searchedPushpinParts(); let i = index;">
                            <div (click)="openPushpin(pushpinPart.pushpin['id'], pushpinPart.id)" class="list-item curpoint item{{i}}">
                                <div
                                    [class.filter-visible]="filterComponent.filterVisible()"
                                    [style.background-image]="pushpinPart.images[0].image|safeBgUrl"
                                    class="image">
                                    <div class="date">
                                        {{pushpinPart.updated_at | date : 'd MMM yyyy, H:mm'}}
                                    </div>
                                    @if (showName() || pushpinPart.pushpin['consumer_created']) {
                                        <div class="username">
                                            {{pushpinPart.pushpin['user_name']}}
                                        </div>
                                    }
                                </div>
                                <div class="info">
                                    <div class="main">
                                        <div class="address">
                                            <div class="h4">
                                                {{pushpinPart.pushpin.street}} {{pushpinPart.pushpin.housenumber}}
                                            </div>
                                            <div class="place">
                                                {{pushpinPart.pushpin.place}}
                                            </div>
                                        </div>
                                        <div class="number">
                                            <div>
                                                @if (pushpinPartPricesMap()[pushpinPart.id] && showPrice()) {
                                                    <div class="price">
                                                        <span class="eu">€</span>
                                                        {{pushpinPartPricesMap()[pushpinPart.id] | number:'1.2-2'}}
                                                    </div>
                                                }
                                                <div class="nr">
                                                    {{pushpinPart.pushpin.number}}
                                                </div>
                                                @if (pushpinPart['loading']) {
                                                    <div>
                                                        <i class="fas fa-circle-notch fa-spin"></i>
                                                    </div>
                                                }
                                                @if (!pushpinPart['loading'] && inspection()?.inspection_type_id === 1 && !inspection()?.lock &&
                                                ((inspection()?.inspection_status.selection_allowed && this.AuthorisationService.hasFeature('priceList')) ||
                                                    (inspection()?.inspection_status_id === 2 && AuthorisationService.hasFeature('pushpinPartReleaseConsumer')))) {
                                                    <i (click)="setSelection($event, pushpinPart)"
                                                       [class.fa-check-square]="pushpinPart['checked'] && !pushpinPart['loading']"
                                                       [class.fa-square]="!pushpinPart['checked']"
                                                       class="far"></i>
                                                }
                                            </div>
                                            <div class="reference">
                                                {{pushpinPart.pushpin?.reference}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="part">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="d-flex flex-wrap row pt-1">
                                                    <div class="col-2 title">Status</div>
                                                    <div class="col-4 property">
                                                        @if (pushpinPart?.deleted_at) {
                                                            <span>Verwijderd&nbsp;</span>
                                                        }
                                                        <span [class.deleted]="pushpinPart?.deleted_at">{{pushpinPart.status.name}}</span>
                                                        @if (pushpinPart.status_id === 9) {
                                                            <small>{{pushpinPart.updated_at | date  : 'd MMM yyyy, H:mm'}}</small>
                                                        }
                                                    </div>
                                                    @if (pushpinPart.decoration.name) {
                                                        <div class="col-2 title">{{pushpinPart.decoration.type}}</div>
                                                        <div class="col-4 property">{{pushpinPart.decoration.name}}</div>
                                                    }
                                                    <div class="col-2 title">Materiaal</div>
                                                    <div class="col-4 property">
                                                        <span [class.no-material]="pushpinPart.exclusive_material">
                                                            {{pushpinPart.material.name}}
                                                        </span>
                                                        {{pushpinPart.primer ? ', Primer' : ''}}
                                                    </div>
                                                    <div class="col-2 title">Kleur</div>
                                                    <div class="col-4 property">{{pushpinPart.paint_color.name}}</div>
                                                    <div class="col-2 title">Uitzetten</div>
                                                    <div class="col-4 property">{{pushpinPart.stake_out ? 'Ja' : 'Nee'}}</div>
                                                    <div class="col-2 title">Stralen</div>
                                                    <div class="col-4 property">{{pushpinPart.blast ? 'Ja' : 'Nee'}}</div>
                                                    @if (pushpinPart.decoration.type != 'Lengtemarkering') {
                                                        <div class="col-2 title">Aantal</div>
                                                        <div class="col-4 property">{{pushpinPart.amount}}</div>
                                                    }
                                                    @if (pushpinPart.decoration.type != 'Diversen vervangen' && !pushpinPart.decoration.specify_length) {
                                                        <div class="col-2 title">Oppervlakte</div>
                                                        <div class="col-4 property">{{pushpinPart.surface | number:'1.0-2'}}
                                                            m<sup>2</sup>
                                                        </div>
                                                    }
                                                    @if (pushpinPart.decoration.specify_length) {
                                                        <div class="col-2 title">Lengte</div>
                                                        <div class="col-4 property">{{pushpinPart.length| number:'1.0-0'}}
                                                            m
                                                        </div>
                                                    }
                                                    @if (pushpinPart.overgrown) {
                                                        <div class="col-6 title">Overgroeide kanten</div>
                                                    }
                                                    @if (pushpinPart.status_id === 9 && pushpinPart['executedDate']) {
                                                        <div class="col-2 title">Uitgevoerd op</div>
                                                        <div
                                                            class="col-4 property">{{pushpinPart['executedDate'] | date  : 'd MMM yyyy, H:mm'}}
                                                        </div>
                                                    }
                                                    @if (pushpinPart.description && showName()) {
                                                        <div class="col-12">
                                                            <div class="title">Opmerking</div>
                                                            <div class="partDescription">
                                                                {{pushpinPart.description}}
                                                            </div>
                                                        </div>
                                                    }
                                                    @if (pushpinPart.customer_note) {
                                                        <div class="col-12">
                                                            @if (showName()) {
                                                                <div class="title">Opmerking Klant</div>
                                                            } @else {
                                                                <div class="title">Opmerking</div>
                                                            }
                                                            <div>
                                                                {{pushpinPart.customer_note}}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </cdk-virtual-scroll-viewport>
            }
        </div>
    }
</div>
<app-vvr-icon [dark]="false" [full]="false" [overlay]="true" [shadow]="true"></app-vvr-icon>
